import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { ReactComponent as LinkedinIcon } from "feather-icons/dist/icons/linkedin.svg";
import { ReactComponent as GithubIcon } from "feather-icons/dist/icons/github.svg";
import { ReactComponent as MailIcon } from "feather-icons/dist/icons/mail.svg";
import { ReactComponent as GlobeIcon } from "feather-icons/dist/icons/globe.svg";
import { Eyebrow } from "./ui";
import Avatar from "./Avatar";

/** Encart auteur en fin d'article. */

const Card = tw.div`flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left bg-gray-100 rounded-lg p-6 sm:p-8`;
const Portrait = tw(Avatar)`sm:mr-6`;
const Body = tw.div`mt-4 sm:mt-0 flex-1`;
const Name = tw.p`mt-1 text-xl font-bold text-gray-900`;
const Role = tw.p`text-sm font-semibold text-primary-500`;
const Bio = tw.p`mt-3 text-sm text-gray-700 font-medium leading-relaxed`;
const Links = tw.div`mt-4 flex justify-center sm:justify-start`;
const IconLink = styled.a`
  ${tw`w-10 h-10 mr-2 rounded-full bg-gray-200 text-gray-700 flex items-center justify-center transition duration-300`}
  ${tw`hocus:bg-primary-500 hocus:text-gray-100 focus:outline-none focus:shadow-outline`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

export default function AuthorCard({ author }) {
  if (!author) return null;
  const links = author.links || {};
  return (
    <Card>
      <Portrait name={author.name} image={author.image} size={80} />
      <Body>
        <Eyebrow>L'auteur</Eyebrow>
        <Name>{author.name}</Name>
        {author.role && <Role>{author.role}</Role>}
        {author.bio && <Bio>{author.bio}</Bio>}
        {(links.linkedin || links.github || links.email || links.website) && (
          <Links>
            {links.linkedin && (
              <IconLink href={links.linkedin} target="_blank" rel="noopener noreferrer" aria-label={`${author.name} sur LinkedIn`} title="LinkedIn">
                <LinkedinIcon aria-hidden="true" />
              </IconLink>
            )}
            {links.github && (
              <IconLink href={links.github} target="_blank" rel="noopener noreferrer" aria-label={`${author.name} sur GitHub`} title="GitHub">
                <GithubIcon aria-hidden="true" />
              </IconLink>
            )}
            {links.website && (
              <IconLink href={links.website} target="_blank" rel="noopener noreferrer" aria-label={`Site de ${author.name}`} title="Site web">
                <GlobeIcon aria-hidden="true" />
              </IconLink>
            )}
            {links.email && (
              <IconLink href={`mailto:${links.email}`} aria-label={`Écrire à ${author.name}`} title="E-mail">
                <MailIcon aria-hidden="true" />
              </IconLink>
            )}
          </Links>
        )}
      </Body>
    </Card>
  );
}
